import { Component, HostListener, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tour-confirm-dialog',
  imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, TranslateModule],
  styleUrls: ['./tour-exit-confirm-dialog.component.scss'],
  templateUrl: './tour-exit-confirm-dialog.component.html',
})
export class TourExitConfirmDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<TourExitConfirmDialogComponent>);
  dontShow = true;

  @HostListener('document:keydown', ['$event'])
  onKey(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.dialogRef.close(false);
    }
  }
}
